/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AuthRoles } from 'jotai/auth';
import { authService } from 'services/auth/AuthService';

const isStrategyUser = () => {
  const userRoles = authService.getRolesAllRealms();
  const authorizedStrategyRoles: string[] = [AuthRoles.ADMIN, AuthRoles.Strategy];
  return userRoles && userRoles?.some((item) => authorizedStrategyRoles.includes(item));
};

export default isStrategyUser;
